import { readItem, writeItem } from "./storage.js";
import { localizeStr } from "./i18n.js";

// Session-Schicht: wer ist eingeloggt, was passiert bei 401, was bei
// Netzwerkfehlern. Die Seiten pruefen nichts mehr selbst - der Router
// laesst geschuetzte Routen nur mit Session durch (requireAuth), und die
// API meldet eine abgelaufene Session zentral (installSessionHandling).

let app = null;
let handlingUnauthorized = false;

export function installSession(f7) {
    app = f7;
}

export function isLoggedIn() {
    return readItem("is_loggedin", "cookie") === "1" && readItem("bearer", "cookie") !== "";
}

/** Session lokal loeschen (ohne Server-Aufruf, den macht auth.logout). */
export function clearSession() {
    writeItem("bearer", "", "cookie");
    writeItem("is_loggedin", "0", "cookie");
    writeItem("first_name", "", "localStorage");
    writeItem("last_name", "", "localStorage");
}

/**
 * Route-Guard fuer Framework7: in eine Route als `beforeEnter` eintragen.
 * Ohne Session geht es zur Willkommensseite; die Zielroute wird nicht geladen.
 */
export function requireAuth({ resolve, reject, router }) {
    if (isLoggedIn()) {
        resolve();
    } else {
        reject();
        router.navigate("/onboarding/welcome/", { reloadAll: true, animate: false });
    }
}

/**
 * Antwort 401 der API: Session ist serverseitig weg. Einmal aufraeumen und
 * zum Login - auch wenn mehrere Aufrufe gleichzeitig scheitern.
 */
export function onUnauthorized() {
    if (handlingUnauthorized) return;
    handlingUnauthorized = true;
    clearSession();
    app.views.main.router.navigate("/onboarding/welcome/", { reloadAll: true, animate: false });
    app.toast.create({ text: localizeStr("error_session_expired"), closeTimeout: 4000, position: "bottom" }).open();
    setTimeout(() => { handlingUnauthorized = false; }, 1000);
}

/**
 * Fehler eines API-Aufrufs, der nicht 401 ist (Netz weg, 500, Timeout):
 * kurzer Hinweis, Seite bleibt stehen. Fuer die catch-Bloecke der Seiten.
 */
export function apiError(err) {
    if (err?.response?.status === 401) return; // hat onUnauthorized schon
    if (!app) return;
    app.toast.create({ text: localizeStr("error_network_message"), closeTimeout: 4000, position: "bottom" }).open();
}
